import { IGlobalState } from '../../../Root/store/appReducer'

export const getImportDataUploading = (state: IGlobalState) => state.importDataAdmin?.uploading
export const getImportDataResult = (state: IGlobalState) => state.importDataAdmin?.result
